'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export const useTransparentBackground = is3DCommerceTransparentBg => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== is3DCommerceTransparentBg) {
    t0 = () => {
      if (is3DCommerceTransparentBg) {
        const html = document.documentElement;
        const body = document.body;
        html.style.setProperty("background-color", "transparent", "important");
        body.style.setProperty("background-color", "transparent", "important");
        return () => {
          html.style.removeProperty("background-color");
          body.style.removeProperty("background-color");
        };
      }
    };
    t1 = [is3DCommerceTransparentBg];
    $[0] = is3DCommerceTransparentBg;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};